<template>
    <div>
        <div class="font-bold text-xs text-slate-700 mb-2" data-test="sidebar-filter-label">Status</div>
        <vx-box color="info" class="p-4">
            <div class="flex flex-col gap-3">
                <div
                    v-for="option in statusOptions"
                    :key="option.value"
                    class="flex gap-2 items-center text-sm cursor-pointer"
                    :class="{ 'opacity-70 cursor-not-allowed!': isDisabled(option.value) }"
                    :data-test="`status-${option.value}`"
                    tabindex="0"
                    @click.prevent="toggle(option.value)"
                    @keydown.space.prevent="toggle(option.value)"
                    @keydown.enter.prevent="toggle(option.value)"
                >
                    <vx-checkbox :modelValue="modelProxy.includes(option.value)" :tabindex="-1"></vx-checkbox>
                    {{ option.label }}
                </div>
            </div>
        </vx-box>
    </div>
</template>

<script setup>
import { VxBox, VxCheckbox } from '@voxie/frontend-components';
import { computed } from 'vue';
import {
    GROUP_STATUS_ACTIVE,
    GROUP_STATUS_CLOSED,
    GROUP_STATUS_DRAFT,
    GROUP_STATUS_SUSPENDED,
} from '~/constants/groupStatuses';

const statusOptions = [
    { label: 'Draft', value: GROUP_STATUS_DRAFT },
    { label: 'Active', value: GROUP_STATUS_ACTIVE },
    { label: 'Suspended', value: GROUP_STATUS_SUSPENDED },
    { label: 'Closed', value: GROUP_STATUS_CLOSED },
];

const defaultValues = statusOptions.map((option) => option.value);

const model = defineModel({ type: Array, required: false });

const modelProxy = computed({
    get: () => model.value || defaultValues,
    set: (newValues) => {
        model.value = newValues.length ? newValues : defaultValues;
    },
});

const isDisabled = (value) => modelProxy.value.length === 1 && modelProxy.value.includes(value);

const toggle = (value) => {
    if (isDisabled(value)) {
        return;
    }

    const isSelected = modelProxy.value.includes(value);
    if (isSelected && modelProxy.value.length === 1) {
        return;
    }

    const next = new Set(modelProxy.value);
    if (isSelected) {
        next.delete(value);
    } else {
        next.add(value);
    }

    modelProxy.value = defaultValues.filter((status) => next.has(status));
};
</script>
